import { createAsyncThunk } from "@reduxjs/toolkit";

import { downloadFile } from "core/request_utils";

export const getXmlVor = createAsyncThunk("vor/getXmlVor", async ({ vorId, params }, { rejectWithValue, extra, dispatch }) => {
	let response;
	try {
		if (params.source === "CREATE" && params.withJust === false) {
			response = await extra.apiVor.createXmlWithoutJusts({ vorId });
			downloadFile(response);
		} else if (params.source === "CREATE" && params.withJust === true) {
			response = await extra.apiVor.createXmlWithJusts({ vorId });
			downloadFile(response);
		} else if (params.source === "SOURCE" && params.withJust === false) {
			response = await extra.apiVor.getSourceXmlWithoutJusts({ vorId });
			downloadFile(response);
		} else if (params.source === "SOURCE" && params.withJust === true) {
			response = await extra.apiVor.getSourceXmlWithJusts({ vorId });
			downloadFile(response);
		}
	} catch (e) {
		return rejectWithValue(e);
	}
});
